"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = void 0;
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var EditText = function (_a) {
    var name = _a.name, value = _a.value, setValue = _a.setValue, submit = _a.submit;
    var _b = react_1.useState(false), editing = _b[0], setEditing = _b[1];
    return react_1.default.createElement(react_1.default.Fragment, null,
        !editing &&
            react_1.default.createElement("span", { className: 'flex-grow' }, value),
        editing &&
            react_1.default.createElement(storybook_1.Forms.Input, { className: 'mb-0', value: value, onChange: function (value) {
                    var _a;
                    return setValue((_a = {}, _a[name] = value, _a));
                } }),
        react_1.default.createElement("span", { className: "ml-4 flex-shrink-0" },
            react_1.default.createElement(storybook_1.Buttons.Button, { className: 'text-link', onClick: function () {
                    if (editing) {
                        submit();
                    }
                    setEditing(!editing);
                } }, editing ? 'Opslaan' : 'Wijzigen')));
};
var PasswordModal = function (_a) {
    var open = _a.open, setOpen = _a.setOpen;
    return react_1.default.createElement(storybook_1.Modals.Modal, { open: open, onClose: function () { return setOpen(!open); } },
        react_1.default.createElement(storybook_1.Modals.Container, null,
            react_1.default.createElement(storybook_1.Modals.Body, null,
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-2' }, "Check je mailbox"),
                react_1.default.createElement(storybook_1.Texts.Primary, null, "We hebben je een link gestuurd om je wachtwoord te herstellen.")),
            react_1.default.createElement(storybook_1.Modals.Footer, null,
                react_1.default.createElement(storybook_1.Buttons.Button, { type: 'default', onClick: function () { return setOpen(!open); } }, "Close"))));
};
var Settings = function (_a) {
    var user = _a.user, channel = _a.channel, preferences = _a.preferences;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    var _c = react_1.useState(false), open = _c[0], setOpen = _c[1];
    var _d = ra_fetch_1.useApi('auth').update('user', {
        name: user.name,
        email: user.email
    }), model = _d[0], setModel = _d[1], submitModel = _d[2];
    var _e = ra_fetch_1.useApi('auth').store('password.forgot', {
        email: user.email
    }), forgot = _e[0], setForgot = _e[1], submitForgot = _e[2];
    return react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(PasswordModal, { open: open, setOpen: setOpen }),
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1' }, "Mijn profiel"),
        react_1.default.createElement(storybook_1.Cards.Card, { className: 'my-5' },
            react_1.default.createElement(storybook_1.Lists.Header, null,
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Mijn gegevens")),
            react_1.default.createElement(storybook_1.Lists.List, null,
                react_1.default.createElement(storybook_1.Lists.Row, null,
                    react_1.default.createElement(storybook_1.Lists.Column, { type: 'dt' }, "Naam"),
                    react_1.default.createElement(storybook_1.Lists.Column, { type: 'dd', colSpan: 2 },
                        react_1.default.createElement(EditText, { user: model.data, name: 'name', value: model.data.name, setValue: setModel, submit: submitModel }))),
                react_1.default.createElement(storybook_1.Lists.Row, null,
                    react_1.default.createElement(storybook_1.Lists.Column, { type: 'dt' }, "E-mailadres"),
                    react_1.default.createElement(storybook_1.Lists.Column, { type: 'dd', colSpan: 2 }, user.email)),
                Boolean(model.errors.length) && react_1.default.createElement(storybook_1.Forms.Errors, { errors: model.errors }))),
        preferences && react_1.default.createElement(storybook_1.Users.Preferences, null),
        channel.id && react_1.default.createElement(storybook_1.Users.Tokens, { setModal: setModal, closeModal: closeModal }));
};
exports.Settings = Settings;
exports.Settings.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        permissions: prop_types_1.default.array,
    }),
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number,
    }),
    /**
     * If preferences is visible
     */
    preferences: prop_types_1.default.bool
};
exports.Settings.defaultProps = {};
